import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../App';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { loginWithGoogle, verifyMagicLink } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Check for Google OAuth session_id in hash
        if (location.hash?.includes('session_id=')) {
          const hashParams = new URLSearchParams(location.hash.substring(1));
          const sessionId = hashParams.get('session_id');
          
          if (sessionId) {
            await loginWithGoogle(sessionId);
            toast.success('Welcome! Logged in with Google');
            navigate('/dashboard', { replace: true });
            return;
          }
        }

        // Check for magic link token
        const magicToken = searchParams.get('token');
        if (magicToken) {
          await verifyMagicLink(magicToken);
          toast.success('Welcome! Logged in successfully');
          navigate('/dashboard', { replace: true });
          return;
        }

        // No valid auth data found
        toast.error('Invalid authentication');
        navigate('/login', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error(error.response?.data?.detail || 'Authentication failed');
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
